import { render, staticRenderFns } from "./form_add.vue?vue&type=template&id=37fb9604&scoped=true&"
import script from "./form_add.vue?vue&type=script&lang=js&"
export * from "./form_add.vue?vue&type=script&lang=js&"
import style0 from "./form_add.vue?vue&type=style&index=0&id=37fb9604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb9604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fb9604')) {
      api.createRecord('37fb9604', component.options)
    } else {
      api.reload('37fb9604', component.options)
    }
    module.hot.accept("./form_add.vue?vue&type=template&id=37fb9604&scoped=true&", function () {
      api.rerender('37fb9604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/task_manage/work_task/form/components/form_add.vue"
export default component.exports